import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Registro from './pages/Registro';
import Dashboard from './pages/Dashboard';
import Tickets from './pages/Tickets';
import Clientes from './pages/Clientes';
import Usuarios from './pages/Usuarios';
import Reportes from './pages/Reportes';
import Implementaciones from './pages/Implementaciones';
import NuevoTicket from './pages/NuevoTicket';

function RutaProtegida({ children }) {
  const { usuario, cargando } = useAuth();
  if (cargando) return <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', fontFamily:'sans-serif', color:'#666' }}>Cargando...</div>;
  return usuario ? children : <Navigate to="/login" />;
}

function RutaAdmin({ children }) {
  const { usuario, cargando } = useAuth();
  if (cargando) return null;
  if (!usuario) return <Navigate to="/login" />;
  if (usuario.rol !== 'admin') return <Navigate to="/" />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login"        element={<Login />} />
          <Route path="/registro"     element={<Registro />} />
          <Route path="/nuevo-ticket" element={<NuevoTicket />} />
          <Route path="/"                  element={<RutaProtegida><Dashboard /></RutaProtegida>} />
          <Route path="/tickets"           element={<RutaProtegida><Tickets /></RutaProtegida>} />
          <Route path="/clientes"          element={<RutaProtegida><Clientes /></RutaProtegida>} />
          <Route path="/reportes"          element={<RutaProtegida><Reportes /></RutaProtegida>} />
          <Route path="/implementaciones"  element={<RutaProtegida><Implementaciones /></RutaProtegida>} />
          <Route path="/usuarios"          element={<RutaAdmin><Usuarios /></RutaAdmin>} />
          <Route path="*"                  element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;